import React from "react";
import ToastContent from "../../components/ToastContent/ToastContent";
import CustomCrossIcon from "./CustomCrossIcon";
import { toast } from "react-toastify";

export const ToastMessage = (status, message, shouldAutoDismiss = true) => {
  status
    ? toast.success(<ToastContent status={status} message={message ?? ""} />, {
      closeButton: (<CustomCrossIcon isSuccess={status} onClose={toast.dismiss} />),
    })
    : toast.error(<ToastContent status={status} message={message ?? ""} />, {
      closeButton: (<CustomCrossIcon isSuccess={status} onClose={toast.dismiss} />),
    });

  if (shouldAutoDismiss) {
    setTimeout(() => {
      toast.dismiss();
    }, 5000);
  }
};
